// extracted by mini-css-extract-plugin
export default {"text":"LanguageSwitch_text__nzNsQ","languageBtn":"LanguageSwitch_languageBtn__PuS2h","languageOptions":"LanguageSwitch_languageOptions__wClY8"};